import { Action } from '@ngrx/store';
import { NewVersion, Versions, VersionsFilter } from '@usimweb/core/models';

export const LOAD_VERSIONS = '[Project] Load Versions';
export const LOAD_VERSIONS_FAIL = '[Project] Load Versions Fail';
export const LOAD_VERSIONS_SUCCESS = '[Project] Load Versions Success';

export const DELETE_VERSION = '[Project] Delete Version Success';
export const DELETE_VERSION_FAIL = '[Project] Delete Version Fail';
export const DELETE_VERSION_SUCCESS = '[Project] Delete Version Success';

export const RENAME_VERSION = '[Project] Rename Version';
export const RENAME_VERSION_FAIL = '[Project] Rename Version Fail';
export const RENAME_VERSION_SUCCESS = '[Project] Rename Version Success';

export const CREATE_VERSION = '[Version] Create Version';
export const CREATE_VERSION_FAIL = '[Version] Create Version Fail';
export const CREATE_VERSION_SUCCESS = '[Version] Create Version Success';

export const POLL_VERSION = '[Version] Poll Version';
export const POLL_VERSION_FAIL = '[Version] Poll Version Fail';
export const POLL_VERSION_SUCCESS = '[Version] Poll Version Success';

export const POLL_VERSIONS = '[Version] Poll Versions';
export const POLL_VERSIONS_FAIL = '[Version] Poll Versions Fail';
export const POLL_VERSIONS_SUCCESS = '[Version] Poll Versions Success';

export const GET_VERSION_BY_ID = '[Version] Get  version by id';
export const GET_VERSION_BY_ID_FAIL = '[Version] Get  version by id Fail';
export const GET_VERSION_BY_ID_SUCCESS = '[Version] Get  version by id SUCCESS';

export const SET_FILTER = '[Project] Set filter';
export const GET_VERSIONS = '[Project] Get Version';
export const GO_NEW_VERSION = '[Version] Go to new version';
export const SET_CURR_VERSION = '[Version] Set current version';
export const GET_CURR_VERSION = '[Version] Get current version';
export const CLEAR_CURR_VERSION = '[Version] Clear current version';
export const CLEAR_VERSIONS = '[Version] Clear versions';
export const CANCEL_POLLING = '[Version] Cancel versions polling';

export class LoadVersions implements Action {
  readonly type = LOAD_VERSIONS;
  constructor(public payload: string) {}
}

export class LoadVersionsFail implements Action {
  readonly type = LOAD_VERSIONS_FAIL;
  constructor(public payload: any) {}
}

export class LoadVersionsSuccess implements Action {
  readonly type = LOAD_VERSIONS_SUCCESS;
  constructor(public payload: Versions[]) {}
}

export class CreateVersion implements Action {
  readonly type = CREATE_VERSION;
  constructor(public payload: NewVersion) {}
}

export class CreateVersionFail implements Action {
  readonly type = CREATE_VERSION_FAIL;
  constructor(public payload: any) {}
}

export class CreateVersionSuccess implements Action {
  readonly type = CREATE_VERSION_SUCCESS;
  constructor(public payload: Versions) {}
}

export class DeleteVersion implements Action {
  readonly type = DELETE_VERSION;
  constructor(public payload: Versions) {}
}

export class DeleteVersionFails implements Action {
  readonly type = DELETE_VERSION_FAIL;
  constructor(public payload: any) {}
}

export class DeleteVersionSuccess implements Action {
  readonly type = DELETE_VERSION_SUCCESS;
  constructor(public payload: Versions) {}
}

export class ClearVersions implements Action {
  readonly type = CLEAR_VERSIONS;
  constructor() {}
}

export class RenameVersion implements Action {
  readonly type = RENAME_VERSION;
  constructor(public payload: { uuid: string; name: any }) {}
}

export class RenameVersionFail implements Action {
  readonly type = RENAME_VERSION_FAIL;
  constructor(public payload: any) {}
}

export class RenameVersionSuccess implements Action {
  readonly type = RENAME_VERSION_SUCCESS;
  constructor(public payload: { uuid: string; name: any; history?: Versions[] }) {}
}

export class GetVersions implements Action {
  readonly type = GET_VERSIONS;
  constructor(public payload: Versions[]) {}
}

export class SetFilter implements Action {
  readonly type = SET_FILTER;
  constructor(public payload: VersionsFilter) {}
}

export class GoNewVersion implements Action {
  readonly type = GO_NEW_VERSION;
  constructor(public payload: string) {}
}

export class CancelPolling implements Action {
  readonly type = CANCEL_POLLING;
}

export class PollVersion implements Action {
  readonly type = POLL_VERSION;
  constructor(public payload: string) {}
}

export class PollVersionFail implements Action {
  readonly type = POLL_VERSION_FAIL;
  constructor(public payload: any) {}
}

export class PollVersionSuccess implements Action {
  readonly type = POLL_VERSION_SUCCESS;
  constructor(public payload: Versions) {}
}

export class PollVersions implements Action {
  readonly type = POLL_VERSIONS;
  constructor(public payload: string) {}
}

export class PollVersionsFail implements Action {
  readonly type = POLL_VERSIONS_FAIL;
  constructor(public payload: any) {}
}

export class PollVersionsSuccess implements Action {
  readonly type = POLL_VERSIONS_SUCCESS;
  constructor(public payload: Versions[]) {}
}

export class SetCurrVersion implements Action {
  readonly type = SET_CURR_VERSION;
  constructor(public payload: Versions) {}
}

export class GetCurrVersion implements Action {
  readonly type = GET_CURR_VERSION;
  constructor(public payload: string) {}
}

export class ClearCurrentVersion implements Action {
  readonly type = CLEAR_CURR_VERSION;
  constructor() {}
}

export class GetVersioByid implements Action {
  readonly type = GET_VERSION_BY_ID;
  constructor(public payload: string) {}
}

export class GetVersioByidFail implements Action {
  readonly type = GET_VERSION_BY_ID_FAIL;
  constructor(public payload: any) {}
}

export class GetVersioByidSuccess implements Action {
  readonly type = GET_VERSION_BY_ID_SUCCESS;
  constructor(public payload: Versions) {}
}

export type VersionsActions =
  | LoadVersions
  | LoadVersionsFail
  | LoadVersionsSuccess
  | CreateVersion
  | CreateVersionFail
  | CreateVersionSuccess
  | DeleteVersion
  | DeleteVersionFails
  | DeleteVersionSuccess
  | RenameVersion
  | RenameVersionFail
  | RenameVersionSuccess
  | GetVersioByid
  | GetVersioByidFail
  | GetVersioByidSuccess
  | SetFilter
  | SetCurrVersion
  | GetVersions
  | GoNewVersion
  | PollVersion
  | PollVersionFail
  | PollVersionSuccess
  | PollVersions
  | PollVersionsFail
  | PollVersionsSuccess
  | GetCurrVersion
  | ClearCurrentVersion
  | ClearVersions;
